import React from 'react'
import resolveProps from '../../../utils/resolveProps'
import { SpinnerProps } from './types'

const config = {
  types: [],
  modifiers: [
    {
      title: 'default',
      isDefault: true
    },
    'inverse'
  ],
  states: []
}

export default function Spinner(props: SpinnerProps) {
  const { isLoading, inverse } = props

  return isLoading ? (
    <div className={resolveProps(props, config, 'Spinner')}>
      <span className="mdn-Icon-claro mdn-Icon--lg" />
    </div>
  ) : (
    <></>
  )
}